// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  CreateMultifamilyFeesRequestDto,
  GetMultifamilyFeesResponseDto,
  ListingAlias,
  MultifamilyFeeDto,
  UpdateFeedImportedMultifamilyFeesRequestDto,
  UpdateMultifamilyFeesRequestDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface DeleteParams {
  feeGroupId: string;
  listingAlias: ListingAlias;
}
interface GetParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Args {
  postData: CreateMultifamilyFeesRequestDto;
}

export type RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Options = UseMutationOptions<
  MultifamilyFeeDto,
  unknown,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Args
>;

/**
 * Creates one or more fees for a multi family listing
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Args
>;

/**
 * Deletes a group of fees for a multi family listing
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Options = UseQueryOptions<
  GetMultifamilyFeesResponseDto,
  unknown,
  GetMultifamilyFeesResponseDto,
  readonly [string, GetParams]
>;

const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_queryOptions = (
  getParams: GetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve all fees for a given multi family listing
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get.getKey =
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_get_GetKey;

export interface RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Args {
  postData: UpdateMultifamilyFeesRequestDto;
}

export type RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Options = UseMutationOptions<
  MultifamilyFeeDto,
  unknown,
  RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Args
>;

/**
 * Updates one or more fees for a multi family listing
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update_Args) =>
      RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_update(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Args {
  postData: UpdateFeedImportedMultifamilyFeesRequestDto;
}

export type RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Options =
  UseMutationOptions<
    MultifamilyFeeDto,
    unknown,
    RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Args
  >;

/**
 * Updates name and description of a group of fees imported from feed
 */
export const useRentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees_Args) =>
      RentalManagerUserPropertyMultifamilyCostAndFeesWebApiHandler_updateFeedImportedFees(args.postData, httpClient),
  });
};
